import { t } from "@i18n";
import { observer, Switch } from "@legendapp/state/react";
import { Card } from "react-bootstrap"
import _Table from "_components/Table";
import { UserDeskHub } from "_services/ws/user-desk-hub";
import { iso2date } from "_utils/date";
import { DeskCell } from "_pages/service/queue/components/table/DeskCell";
import { TimeOnQueueCell } from "_pages/service/queue/components/table/TimeOnQueueCell";
import { ActionsCell } from "_pages/service/queue/components/table/ActionsCell";
import { $onFilterChange, Filters, filters } from "_pages/service/queue/components/table/Filters";
import { VStack } from "_ui/Box";
import { Unless, When } from "react-if";
import { MyAttendancesTable } from "_pages/service/queue/components/table/my-attendances";
import { AttendanceNotStarted } from "_pages/service/queue/components/AttendanceNotStarted";
import { useCurrentAttendanceSession } from "_api/hooks/attendances";
import { AllAttendancesTable } from "_pages/service/queue/components/table/all-attendances";
import { Suspense } from "react";
import TableSuspense from "_components/suspense/TableSuspense";
import { CurrentAttendanceSession } from "_types/responses/current-attendance-session";

const columns = [
    {
        Header: 'Posição',
        accessor: 'queueInfo.pos',
    },
    {
        Header: 'Na fila há',
        accessor: 'queueInfo.enteredAt',
        Cell: TimeOnQueueCell
    },
    {
        Header: 'Nome',
        accessor: 'name',
    },
    {
        Header: 'CPF',
        accessor: 'cpf',
    },
    {
        Header: 'Balcão',
        accessor: 'deskId',
        Cell: DeskCell
    },
    {
        Header: t('Actions'),
        accessor: 'id',
        Cell: ActionsCell,
    },
];

const OnQueue = observer(({ attendanceSession }: { attendanceSession: CurrentAttendanceSession }) => {
    const data = UserDeskHub.$allDesksInfo.$.sort((a, b) => iso2date(a.queueInfo.enteredAt)!.toUnixInteger() - iso2date(b.queueInfo.enteredAt)!.toUnixInteger()!);

    return (<>
        <When condition={!!attendanceSession && UserDeskHub.$desksJoined.get()}>
            <Suspense fallback={<TableSuspense columns={columns.length} rows={7} />}>
                <_Table
                    {...{ columns, data }}
                    emptyText='Nenhum solicitante na fila'
                    isSortable
                />
            </Suspense>
        </When>

        <When condition={!!attendanceSession && !UserDeskHub.$desksJoined.get()}>
            <TableSuspense columns={columns.length} rows={7} />
        </When>


        <Unless condition={!!attendanceSession}>
            <AttendanceNotStarted />
        </Unless>
    </>)
});

export const Table = observer(() => {
    const { attendanceSession } = useCurrentAttendanceSession();

    const filters = $onFilterChange.get();

    return (
        <Card className='w-100'>
            <Card.Body>
                <VStack wFull className="mb-2">
                    <Filters />
                </VStack>

                <Switch value={() => $onFilterChange.$.getFilterValue('viewSelector') as any}>
                    {{
                        my: () => <MyAttendancesTable />,
                        all: () => <AllAttendancesTable />,
                        default: () => <OnQueue {...{ attendanceSession }} />
                    }}
                </Switch>
            </Card.Body>
        </Card>
    )
})
